import * as React from 'react';
import { ILxsAnchorContainerViewProps } from './lxs-anchor-container';

const LxsAnchorContainerView: React.FC<ILxsAnchorContainerViewProps> = props => {
    const CLASS_NAME = 'lxs-anchor-container';
    const links = props.slots?.links;

    if (!links?.length) {
        return null;
    }

    return (
        <nav className={CLASS_NAME}>
            {links.map((link, index) => (
                <div key={index} className={`${CLASS_NAME}__item`}>
                    {link}
                </div>
            ))}
        </nav>
    );
};

export default LxsAnchorContainerView;
